import { p as proxyCustomElement, H, h, d as Host } from './p-BJEvNVLM.js';

const cosmosIconCss = ":host{color:var(--cosmos-icon-color, inherit);display:inline-block;height:var(--cosmos-icon-size, 1em);vertical-align:-0.1551724138em;width:var(--cosmos-icon-size, 1em)}svg,::slotted(svg){display:block;height:100%;width:100%}";

const CosmosIconPhone$1 = /*@__PURE__*/ proxyCustomElement(class CosmosIconPhone extends H {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
    }
    getRole() {
        return this.ariaLabel ? 'img' : undefined;
    }
    getAriaHidden() {
        return this.ariaLabel ? false : 'true';
    }
    render() {
        return (h(Host, { key: '939c642b576173ea5a4337e5019a3509bc76995c', role: this.getRole(), "aria-hidden": this.getAriaHidden(), "aria-label": this.ariaLabel }, h("svg", { key: '2a5832ccbf66e5513cfc8005c1b5cd688f4d8500', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", part: "base" }, h("path", { key: '314b094363aaae7238d9cc60b09dc7054fbbebe7', "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M15.5 3h-9a.5.5 0 0 0-.5.51v13.98a.5.5 0 0 0 .5.51h9a.5.5 0 0 0 .5-.51V3.51a.51.51 0 0 0-.5-.51m-1 12.5h-7v-11h7z", fill: "currentColor" }))));
    }
    static get style() { return cosmosIconCss; }
}, [1, "cosmos-icon-phone", {
        "ariaLabel": [513, "aria-label"]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["cosmos-icon-phone"];
    components.forEach(tagName => { switch (tagName) {
        case "cosmos-icon-phone":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, CosmosIconPhone$1);
            }
            break;
    } });
}

const CosmosIconPhone = CosmosIconPhone$1;
const defineCustomElement = defineCustomElement$1;

export { CosmosIconPhone, defineCustomElement };
